import globalStore from "@/store";

export default (apiInstance) => ({
  // VOD 정보 단건 조회
  reqGetVod: async (store, { id }) => {
    const result = await apiInstance.vods.getVod({ id });
    return result;
  },
});
